import { createAction, props } from '@ngrx/store';
import { SearchResult } from '@polaris-customerweb/sharedcomponents.search';

export const CanSearchAgain = createAction(
    '[Search] Can Search Again',
    props<{ canSearchAgain: boolean }>()
);

export const SearchAgain = createAction(
    '[Search] Should Search Again',
    props<{ searchAgain: boolean }>()
);

export const SetSearchResults = createAction(
    '[Search] Set Search Results',
    props<{ searchResults: SearchResult[] }>()
);

export const AppendSearchResults = createAction(
    '[Search] Append Search Results',
    props<{ searchResults: SearchResult[] }>()
);

export const SetActiveSearchResult = createAction(
    '[Search] Set Active Search Result',
    props<{ activeSearchResult: SearchResult | undefined }>()
);

export const SetIsSearchActive = createAction(
    '[Search] Set Is Search Active',
    props<{ searchIsActive: boolean }>()
);

export const SetSearchQuery = createAction(
    '[Search] Set Search Query',
    props<{ query: string }>()
);
